import httpClient from '@/http-client'

export const get = (Options = {}) => {
    return httpClient
        .get('/api/student-vehicles', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/student-vehicles', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
    return httpClient
        .put('/api/student-vehicles', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const vehicle = (Options = {}) => {
    return httpClient
        .get('/api/student-vehicles/vehicles', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const getStudentRegister = vehicleId => {
    return httpClient
        .get(`/api/student-vehicles/${vehicleId}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default {
    get,
    store,
    vehicle,
    update,
    getStudentRegister
}
